var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      attrs: {
        size: "small",
        clearable: "",
        filterable: "",
        remote: "",
        "remote-method": function(keyword) {
          return _vm.searchRole(keyword)
        },
        placeholder: _vm.placeholder || _vm.$t("txt.targetRole")
      },
      on: { input: _vm.inputChange },
      model: {
        value: _vm.roleId,
        callback: function($$v) {
          _vm.roleId = $$v
        },
        expression: "roleId"
      }
    },
    _vm._l(_vm.roleList, function(item) {
      return _c("el-option", {
        key: item.id,
        attrs: { label: item.name, value: item.id }
      })
    })
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3baa285d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3baa285d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/targetUsers/targetRole.vue
// module id = null
// module chunks = 